import { useCallback } from 'react'
import { Debt, DebtAttributes } from '~/shared/api'
import {
  FetchFn,
  SCROLLABLE_LIST_META_PAGE,
  ScrollableList,
  Item,
} from '~/shared/ui/ScrollableList'
import { Card } from './ui/Card'

type Row = Item & DebtAttributes

export const QUERY_KEY_LIST_DEBTS = 'list-debts'

export function ListDebts() {
  const fetchRows = useCallback<FetchFn<Row>>(
    async (page, pageSize, filters, sort) => {
      let builder = Debt.limit(pageSize).orderBy('-createdAt')

      sort && (builder = builder.orderBy(sort))

      filters?.forEach(({ key, value }) => {
        builder = builder.where(key, value)
      })

      const response = await builder.get(page)
      const data = response.getData()

      const items = data.map((bookingCar) => {
        return {
          id: bookingCar?.getApiId() as string,
          ...bookingCar.getAttributes(),
        }
      })

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const { to, currentPage, lastPage } =
        axiosResponse?.data?.meta?.page || SCROLLABLE_LIST_META_PAGE

      return {
        items,
        to,
        currentPage,
        lastPage,
      }
    },
    [],
  )

  const handleMapItems = useCallback(
    (items: Row[]) => (
      <>
        {items.map(({ id, ...attr }) => (
          <div style={{ marginBottom: '12px' }} key={id}>
            <Card debtId={id} attributes={attr} />
          </div>
        ))}
      </>
    ),
    [],
  )

  return (
    <ScrollableList
      queryKey={QUERY_KEY_LIST_DEBTS}
      fetchFn={fetchRows}
      mapItems={handleMapItems}
      skeletonHeight={81}
      skeletonItemMarginBottom='12px'
      empty={
        <div style={{ fontSize: '18px', marginTop: '40px' }}>
          Задолженности не найдены asdfsdf
        </div>
      }
    />
  )
}
